import f from "./extends3.mjs";
import * as u from "react";
import { clsx as x } from "./clsx.mjs";
import { getPickersToolbarUtilityClass as b } from "./pickersToolbarClasses.mjs";
import { jsxs as h, jsx as a } from "react/jsx-runtime";
import i from "./styled.mjs";
import y from "./useThemeProps.mjs";
import T from "./Typography.mjs";
import v from "./composeClasses.mjs";
const P = (e) => {
  const {
    classes: o,
    isLandscape: t
  } = e;
  return v({
    root: ["root"],
    content: ["content"],
    penIconButton: ["penIconButton", t && "penIconButtonLandscape"]
  }, b, o);
}, g = i("div", {
  name: "MuiPickersToolbar",
  slot: "Root",
  overridesResolver: (e, o) => o.root
})(({
  theme: e,
  ownerState: o
}) => f({
  display: "flex",
  flexDirection: "column",
  alignItems: "flex-start",
  justifyContent: "space-between",
  padding: e.spacing(2, 3)
}, o.isLandscape && {
  height: "auto",
  maxWidth: 160,
  padding: 16,
  justifyContent: "flex-start",
  flexWrap: "wrap"
})), k = i("div", {
  name: "MuiPickersToolbar",
  slot: "Content",
  overridesResolver: (e, o) => o.content
})(({
  ownerState: e
}) => {
  var o;
  return {
    display: "flex",
    flexWrap: "wrap",
    width: "100%",
    justifyContent: e.isLandscape ? "flex-start" : "space-between",
    flexDirection: e.isLandscape ? (o = e.landscapeDirection) != null ? o : "column" : "row",
    flex: 1,
    alignItems: e.isLandscape ? "flex-start" : "center"
  };
}), M = /* @__PURE__ */ u.forwardRef(function(o, t) {
  const s = y({
    props: o,
    name: "MuiPickersToolbar"
  }), {
    children: l,
    className: c,
    toolbarTitle: p,
    hidden: d,
    titleId: m
  } = s, r = s, n = P(r);
  return d ? null : /* @__PURE__ */ h(g, {
    ref: t,
    className: x(n.root, c),
    ownerState: r,
    children: [/* @__PURE__ */ a(T, {
      color: "text.secondary",
      variant: "overline",
      id: m,
      children: p
    }), /* @__PURE__ */ a(k, {
      className: n.content,
      ownerState: r,
      children: l
    })]
  });
});
export {
  M as PickersToolbar
};
//# sourceMappingURL=PickersToolbar.mjs.map
